import { useProjectDocumentsService } from 'nekst-api';
import React from 'react';
import {
  Button,
  ButtonColor,
  ButtonSize,
  useMassUpdateServiceRequired,
  usePopupManager
} from 'ui-builder';
import { ConfirmPositiveActionPopup } from 'features/nekst-widgets';
import { useProjectContext } from '../../view/ProjectContext';

export default function AddToPortalButton() {
  const projectDocumentsService = useProjectDocumentsService();
  const popupManager = usePopupManager();

  const massUpdateService = useMassUpdateServiceRequired();

  const value = massUpdateService.getCheckedIds();

  const projectContext = useProjectContext();

  if (massUpdateService.isEnabled()) {
    return (<Button
      text="Add to Portal"
      size={ButtonSize.SMALL}
      isFilled
      isFlat
      isDisabled={value.length === 0}
      onClick={async () => popupManager.openPopup(<ConfirmPositiveActionPopup
        title="Mass Update: Add Documents to Portal"
        message={`Are you sure you want to add selected documents to the client portal?`}
        submitFormFunc={async () => {
          await projectDocumentsService.addToPortal(projectContext.data!.id, value);
        }}
      />)}
      color={ButtonColor.GREEN}
    />);
  } else {
    return null;
  }

}
